
const sidebarJs = function ($) {

    //if ( !$('.js--fixed-sidebar').length ) return;


    // $('.js--sidebar-phone-icon').on('touchstart tap', function(e){
    //     e.preventDefault();
    //     $('.js--sidebar-phone-number').toggleClass('is--active');
    // });


    // function togglePhoneNumber() {
    //     $('.js--sidebar-phone-number').toggleClass('is--active');
    // }
    //
    // $('.js--sidebar-phone-icon').on('touchstart tap', function(e){
    //     e.preventDefault();
    //     setTimeout("togglePhoneNumber()", 200)
    // });

    var sticky = function (el, limit, scrolltop, scrollDirection) {
        if (scrolltop < limit || scrollDirection == 'down') {
            el.addClass('in');
        } else {
            el.removeClass('in');
            // $('.js--sidebar-phone-number').removeClass('is--active');
        }
    }

    var _limit = 100,
        _scrollTop = $(window).scrollTop();

    sticky($('.js--fixed-sidebar'), _limit, _scrollTop);

    var lastScrollTop = 0;
    var scrollDirection = '';


    $(window).on('scroll', function () {
        _scrollTop = $(window).scrollTop();

        if (_scrollTop < lastScrollTop) {
            scrollDirection = 'down';
        } else {
            scrollDirection = 'up';
        }

        sticky($('.js--fixed-sidebar'), _limit, _scrollTop, scrollDirection);
        lastScrollTop = _scrollTop;
    });

}

export default sidebarJs;
